const AppRoutes = {
    // public routes
    login: params => `/login${params ? `?${params}` : ''}`,
    loginLink: params => `/login-link${params ? `?${params}` : ''}`,
    termsAndConditions: () => '/terms-and-conditions',
    privacyPolicy: () => '/privacy-policy',
    logout: () => '/logout',
    maintenance: () => '/maintenance',
    supportPage: () => '/support',
    activate: () => '/activate',
    forgotPassword: () => '/forgot-password',
    resetPassword: () => '/reset-password/:token?',
    signUp: () => '/signup',
    styleguide: () => '/styleguide',
    iconsReference: () => '/icons-reference',
    supportedBrowsers: () => '/supported-browsers',
    noMatch: () => '/no-match',

    // private routes
    adminRoutes: () => '/admin',
    home: () => '/',
    dashboard: () => '/dashboard',
    fleet: () => '/fleet',
    fleetAsset: equipmentId =>
        `/fleet/${equipmentId ? equipmentId : ':equipmentId'}`,
    fleetAssetById: assetId => `/fleet/equipment?assetId=${assetId}`,
    inviteUser: () => '/users/invite',
    users: () => '/users',
    profile: () => '/profile',
    profilePassword: () => '/profile/password',
    requests: () => '/allRequests',
    requestsExtra: () => '/requests', //Previous existing route that does not exist anymore
    createRequestStepper: () => '/allRequests/create',
    createRepairRequestFlow: () => '/allRequests/create/repair',
    createPartsRequestFlow: () => '/allRequests/create/parts',
    createEstimateRequestFlow: () => '/allRequests/create/estimate',
    createAsset: () => '/create/fleet/asset',
    selectAsset: () => '/requests/assets/select',
    partRequests: () => '/requests/parts',
    plannedMaintenance: () => '/plannedMaintenance',
    rentalRequests: () => '/requests/rental',
    equipmentFinder: () => '/equipment',
    newEquipmentRequest: () => '/equipment/finder/new',
    usedEquipmentRequestForm: () => '/equipment/finder/requestUsed',
    usedEquipmentRequest: () => '/equipment/finder/used',
    usedEquipmentPage: equipmentId =>
        `/equipment/used/${equipmentId ? equipmentId : ':equipmentId'}`,
    viewServiceRequest: (requestId, statusType) =>
        `/allRequests/service/${requestId ? requestId : ':requestId'}${
            statusType ? `/${statusType}` : ''
        }`,
    viewEstimateRequest: estimateId =>
        `/allRequests/estimate/${estimateId ? estimateId : ':estimateId'}`,
    viewSalesRequest: requestId =>
        `/allRequests/sales/${requestId ? requestId : ':requestId'}`,
    viewPartsRequest: requestId =>
        `/allRequests/parts/${requestId ? requestId : ':requestId'}`,
    viewRentalRequest: requestId =>
        `/allRequests/rental/${requestId ? requestId : ':requestId'}`,
    viewPlannedMaintenance: requestId =>
        `/plannedMaintenance/${requestId ? requestId : ':requestId'}`,

    //admin pages
    adminHome: () => '/admin',
    adminAddUser: params => `/admin/add${params ? params : ''}`,
    adminCreateAdmin: () => '/admin/create-admin',
    adminManageAdmins: () => '/admin/manage-admins',
    adminSearch: params => `/admin/search${params ? `${params}` : ''}`,
    adminMaintenaceStatus: () => '/admin/maintenance-status',
    adminFeatureFlags: () => '/admin/feature-flags',
    adminReports: () => '/admin/reports',
}

export default AppRoutes
